import React from 'react';

export function usePrintPlan() {
  const [printDate, setPrintDate] = React.useState(() => formatDate(new Date()));

  const refreshPrintDate = React.useCallback(() => {
    setPrintDate(formatDate(new Date()));
  }, []);

  React.useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    window.addEventListener('beforeprint', refreshPrintDate);
    return () => {
      window.removeEventListener('beforeprint', refreshPrintDate);
    };
  }, [refreshPrintDate]);

  const handlePrint = React.useCallback(() => {
    if (typeof window === 'undefined') return;
    refreshPrintDate();
    window.requestAnimationFrame(() => {
      window.print();
    });
  }, [refreshPrintDate]);

  return { printDate, handlePrint };
}

function formatDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${month}/${day}/${year}`;
}
